import { Station, Id } from 'NSwag/ServerClient/Client.nswag';
import { Action } from 'redux';

export enum RwisStationActionTypes {
    AddRwisStations = 'ADD_RWIS_STATIONS',
    ModifyRwisStations = 'MODIFY_RWIS_STATIONS',
    DeleteRwisStations = 'DELETE_RWIS_STATIONS'
}

export interface AddRwisStations extends Action{
    type: RwisStationActionTypes.AddRwisStations;
    rwisStations: Station[];
}

export interface ModifyRwisStations extends Action {
    type: RwisStationActionTypes.ModifyRwisStations;
    rwisStations: Station[];
}

export interface DeleteRwisStations extends Action {
    type: RwisStationActionTypes.DeleteRwisStations;
    ids: Id[];
}